import { useEffect, useState } from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { subscribe } from "app/services/toast.service";

const AUTO_HIDE_MS = 5000;

/**
 * Single mount point for app-wide toasts. Subscribes to the toast service and renders the
 * current notification as an MUI Snackbar + Alert. Mounted once near the app root.
 */
export const ToastHost = () => {
    const [toast, setToast] = useState(null);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const unsubscribe = subscribe((payload) => {
            setToast(payload);
            setOpen(true);
        });
        return unsubscribe;
    }, []);

    const handleClose = (_event, reason) => {
        if (reason === "clickaway") return;
        setOpen(false);
    };

    if (!toast) {
        return null;
    }

    return (
        <Snackbar
            key={toast.id}
            open={open}
            autoHideDuration={AUTO_HIDE_MS}
            onClose={handleClose}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
            <Alert
                onClose={handleClose}
                severity={toast.severity}
                variant="filled"
                sx={{ width: "100%" }}
            >
                {toast.message}
            </Alert>
        </Snackbar>
    );
};

export default ToastHost;
